export default "__VITE_ASSET__634ce672__"